import { UnavailableDataError } from "./errors";
import type { Aux0Client } from "./types";

/** Route gate runs before loaders, so an unbuilt screen is a product state. */
export function assertSurfaceAvailable(kind: Aux0Client["kind"], pathname: string) {
  if (kind === "fixtures") return;
  const surface = pathname.replace(/^\/p\/[^/]+\/?/, "").split("/")[0] ?? "";
  if (["accounts", "keys", "logs"].includes(surface)) return;
  throw new UnavailableDataError(surface || "overview");
}
